var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tiptap-vuetify',{attrs:{"value":_vm.value,"card-props":{ disabled: true, flat: true },"extensions":_vm.extensions},scopedSlots:_vm._u([{key:"toolbar",fn:function(ref){return [_c('pre')]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }